import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { MwFormBaseSectionComponent } from '../section-base.component';
import { MwFormBehaviorService } from './form-behavior.service';

@Injectable()
export class MwFormDataService {
  get sections$(): Observable<MwFormBaseSectionComponent[]> {
    return this._sections$.asObservable();
  }

  private readonly _sections$ = new BehaviorSubject<
    MwFormBaseSectionComponent[]
  >([]);
  private readonly _rootContainerHeight$ = new BehaviorSubject<number>(0);
  constructor(private readonly behaviorService: MwFormBehaviorService) {}

  addSection(section: MwFormBaseSectionComponent): void {
    if (this.indexOf(section) === -1) {
      const sections = this._sections$.value;
      sections.push(section);
      this._sections$.next(sections);
      this.behaviorService.emitSectionAdded(section);
    }
  }

  removeSection(section: MwFormBaseSectionComponent): void {
    const index = this.indexOf(section);
    if (index > -1) {
      const sections = this._sections$.value;
      sections.splice(index, 1);
      this._sections$.next(sections);
    }
    this.behaviorService.emitSectionRemoved(section);
  }

  private indexOf(section: MwFormBaseSectionComponent): number {
    const sections = this._sections$.value;
    return sections.indexOf(section);
  }
}
